export const flatten = (obj, parent, res = {}) => {
  Object.keys(obj).forEach(key => {
    const propName = parent ? `${parent}[${key}]` : key;
    if (typeof obj[key] === 'object' && obj[key] != null) {
      flatten(obj[key], propName, res);
    } else {
      res[propName] = obj[key];
    }
  });
  return res;
};



// WEBPACK FOOTER //
// ./app/javascript/components/brief/utils/object.js